<div mat-dialog-title>
  <div data-testId="title" class="h4 mb-0">{{data.title}}</div>
  <button mat-icon-button [mat-dialog-close]="false" data-testId="close">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div mat-dialog-content data-testId="message">
  <div [innerHtml]="data.message"></div>
</div>
<div mat-dialog-actions>
  <button
    [attr.data-testId]="data.confirmButtonLabel ?? 'Ok'"
    mat-flat-button
    [color]="data.buttonColor ?? 'warn'"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    <ng-container *ngIf="data.icon">
      <mat-icon [svgIcon]="data.icon" class="icon--visually-alligned"></mat-icon>
    </ng-container>
    {{data.confirmButtonLabel ?? 'Ok'}}
  </button>
  <button
    [attr.data-testId]="data.cancelButtonLabel ?? 'Cancel'"
    *ngIf="!data.hideCancelButton"
    mat-button
    color="primary"
    [mat-dialog-close]="false"
  >
    {{data?.cancelButtonLabel ?? 'Cancel'}}
  </button>
</div>
